import { render, staticRenderFns } from "./main-footer.vue?vue&type=template&id=542693d1&scoped=true&"
import script from "./main-footer.ts?vue&type=script&lang=ts&"
export * from "./main-footer.ts?vue&type=script&lang=ts&"
import style0 from "./main-footer.vue?vue&type=style&index=0&id=542693d1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542693d1",
  null
  
)

export default component.exports